<template>
  <div id="pdpp">
    <div id="pphead">
      {{data.title?data.title:$t('lang.prodpt')}}
      <label>{{data.desc}}</label>
    </div>
    <div id="ppfr">
      <label class="arrbtn" @click="picRoll(0)"></label>
      <div class="ppct" v-for="index in 3" :key="index">
        <label>{{data.data[index-1].label}}</label>
        <img :src="data.data[index-1].pic" />
      </div>
      <label class="arrbtn" @click="picRoll(1)"></label>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    data: Object
  },
  watch: {
 
  },
  data () {
    return {
      
    }
  },
  methods: {
    picRoll (isnext) {
      if (isnext) {
        var item = this.data.data.shift()
        this.data.data.push(item)
      } else {
        var item = this.data.data.pop()
        this.data.data.unshift(item)
      }
    }
  },
  mounted () {
  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#pdpp {
  background: white;
  height: 8.88rem;
  overflow: hidden;
}

#pphead {
  margin-top: 1rem;
  font-size: .6rem;
  font-weight: bold;
  color: #363636;
  text-align: center;
}
#pphead label {
  display: block;
  font-size: .24rem;
  font-weight: normal;
  color: #363636;
  margin-top: .12rem;
  margin-bottom: .9rem;
}

#ppfr {
  text-align: center;
  overflow: hidden;
  user-select: none; 
}
.arrbtn {
  display: inline-block;
  width: .54rem;
  height: .54rem;
  background-image: url('../assets/pic/lnr.png');
  background-size: 100% 100%;
  vertical-align: middle;
  margin-right: .51rem;
  cursor: pointer;
}
.arrbtn:hover {
  background-image: url('../assets/pic/lsr.png');
}
.arrbtn:nth-child(5) {
  background-image: url('../assets/pic/rnr.png');
  margin-left: .51rem;
}
.arrbtn:nth-child(5):hover {
  background-image: url('../assets/pic/rsr.png');
}
.ppct {
  width: 3.97rem;
  height: 2.92rem;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  margin: 0 .09rem 0 .09rem;
}
.ppct img {
  width: 3.97rem;
  height: 2.92rem;
  position: relative;
  z-index: 1;
}
.ppct label {
  position: absolute;
  width: 3.97rem;
  text-align: center;
  height: .62rem;
  font-size: .2rem;
  font-weight: 500;
  color: #FFFFFF;
  line-height: .62rem;
  background: rgba(0, 0, 0, .45);
  margin-top: 2.3rem;
  z-index: 2;
}

</style>
